import { Component, OnInit } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { SharedService } from './shared/services/shared.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'logistics-dashboard';
  idleState = 'Not started.';
  timedOut = false;
  lastPing: Date = new Date();

  constructor(
    private idle: Idle, 
    private keepalive: Keepalive,
    private sharedService: SharedService
  ) {

    // sets an idle timeout of 30 minutes
    idle.setIdle(60);
    // sets a timeout period of 5 seconds. after 30 minutes and 5 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(420);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.showMessage();
    });
    idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
    idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

    // sets the ping interval to 15 seconds
    keepalive.interval(420);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  ngOnInit(): void {
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  showMessage() {
    this.sharedService.setTimeout(true)
    this.reset()
  }
}
